import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';

export const getMIPManageTabs = (
	showKycTab: boolean,
	showBankAccountsTab: boolean
): MantineTabProps<MIP_MANAGE_ROUTES>[] =>
	[
		{
			label: 'tabs.investors',
			value: MIP_MANAGE_ROUTES.INVESTORS,
			icon: 'derived_commuted_structure',
			testId: TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_TAB,
		},
		{
			label: 'tabs.investments_page',
			value: MIP_MANAGE_ROUTES.INVESTMENTS,
			icon: 'plant-grown',
			testId: TEST_ELEMENT_IDS.MIP_MANAGE_INVESTMENTS_TAB,
		},
		{
			label: 'tabs.documents_page',
			value: MIP_MANAGE_ROUTES.DOCUMENTS,
			icon: 'folder',
			testId: TEST_ELEMENT_IDS.MIP_MANAGE_DOCUMENTS_TAB,
		},
		...(showKycTab
			? [
					{
						label: 'tabs.kyc',
						value: MIP_MANAGE_ROUTES.KYC,
						icon: 'person-company',
						testId: TEST_ELEMENT_IDS.MIP_MANAGE_KYC_TAB,
					},
				]
			: []),
		...(showBankAccountsTab
			? [
					{
						label: 'tabs.bank_accounts',
						value: MIP_MANAGE_ROUTES.BANK_ACCOUNTS,
						icon: 'bank-v3',
						testId: TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNTS_TAB,
					},
				]
			: []),
		{
			label: 'tabs.payments',
			value: MIP_MANAGE_ROUTES.PAYMENTS,
			icon: 'money-v3',
			testId: TEST_ELEMENT_IDS.MIP_MANAGE_PAYMENTS_TAB,
		},
	] as MantineTabProps<MIP_MANAGE_ROUTES>[];
